import './style.css';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
const selectWindowInnerSize = (state) => state.windowInnerSize;
const selectNavigateBackLocation = (state) => state.navigateBackLocation;

export default function WaitlistTsAndCs() {
  const windowInnerSize = useSelector(selectWindowInnerSize);
  const navigateBackLocation = useSelector(selectNavigateBackLocation);

  const navigate = useNavigate();

  return (
    <div className="WaitlistTsAndCs Page headline" style={{ height: windowInnerSize.height }}>
      <img
        src={'/images/back-page.png'}
        alt="Back to previous page"
        className="WaitlistTsAndCs__back-btn"
        onClick={() => {
          navigate(navigateBackLocation.page);
        }}
      />
      <div
        style={{
          padding: ' 2vw 5vw 5vw',
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <h1>Waitlist Terms and Conditions</h1>
        <br />
        <p>
          <strong>Last updated: January 5, 2026</strong>
        </p>
        <br />
        <h2>1. Acceptance of Terms</h2>
        <p>
          By joining the waitlist on this website (the &quot;Website&quot;), you agree to be bound by these Waitlist Terms and Conditions (&quot;Terms&quot;). If you do not agree to these Terms, please do not join the waitlist.
        </p>
        <br />
        <h2>2. Waitlist Purpose</h2>
        <p>
          The waitlist allows you to express interest in PassionStocks, a platform focused on personal brand management and related tools. Joining the waitlist does not constitute registration on the platform, access to any services, or eligibility for future participation. Any future use of the platform will be subject to separate terms and conditions.
        </p>
        <br />
        <h2>3. Eligibility</h2>
        <p>
          By joining the waitlist, you confirm that you are at least 13 years old. If you are under the age of 18, you represent that you have permission from a parent or legal guardian to join the waitlist and receive communications from PassionStocks.
        </p>
        <br />
        <h2>4. Communications</h2>
        <p>
          By joining the waitlist, you consent to receive occasional emails from us regarding updates, announcements, and information related to PassionStocks. You may opt out of these communications at any time by contacting us at support.passionstocks@hey.com.
        </p>
        <br />
        <h2>5. No Guarantee of Access</h2>
        <p>
          Joining the waitlist does not guarantee access to the platform, an invitation to register, or availability of any specific features or services. We reserve full discretion regarding if, when, and how we contact waitlist participants.
        </p>
        <br />
        <h2>6. Privacy</h2>
        <p>
          We respect your privacy. Any information you provide when joining the waitlist will be handled in accordance with our Privacy Policy. Please review the Privacy Policy for details on how we collect, use, and protect your information.
        </p>
        <br />
        <h2>7. Informational Nature / No Offer</h2>
        <p>
          All information provided on the Website, including descriptions of current or future features, services, or goals, is for informational purposes only and does not constitute an offer, solicitation, or commitment of any kind. PassionStocks may modify, suspend, or discontinue any aspect of its product, strategy, or offerings at any time without notice or obligation to waitlist participants.
        </p>
        <br />
        <h2>8. FAQs and Social Media</h2>
        <p>
          Content published in our FAQs section or on our social media channels is intended to provide general insight into our vision, direction, and progress. Such content may change over time and should not be relied upon as a binding representation, guarantee, or offer. Availability of features or services may vary based on legal, regulatory, or business considerations.
        </p>
        <br />
        <h2>9. Modifications</h2>
        <p>
          We may update or revise these Waitlist Terms and Conditions at any time. Any changes will become effective upon posting on the Website. Continued participation in the waitlist after changes are posted constitutes acceptance of the revised Terms.
        </p>
        <br />
        <h2>10. Governing Law</h2>
        <p>
          These Waitlist Terms and Conditions are governed by and construed in accordance with the laws of the State of Delaware, United States of America, without regard to its conflict of law principles. Any dispute arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the state and federal courts located in the State of Delaware.
        </p>
        <br />
        <h2>11. Severability</h2>
        <p>
          If any provision of these Terms is found to be unenforceable or invalid, the remaining provisions will remain in full force and effect.
        </p>
        <br />
        <p>&ndash;</p>
        <p>
          <strong>Operator Information</strong>
        </p>
        <p>
          This Website is operated by PassionStocks Inc., a Delaware C-Corporation, with its business address at 149 Commonwealth Drive, Menlo Park, California 94025, United States.
        </p>
      </div>
    </div>
  );
}
